export enum AnalyticsEvent {
  FULL_APP_SUBMITTED = "full_app_submitted",
  PARTIAL_APP_SUBMITTED = "partial_app_submitted",
  SUBMITTED = "submitted",
}
